import { render, staticRenderFns } from "./brandsLetter.vue?vue&type=template&id=7dd6254f"
import script from "./brandsLetter.vue?vue&type=script&lang=js"
export * from "./brandsLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports